import React, { useEffect, useLayoutEffect, useState } from 'react';
import OptionsHeader from './OptionsHeader';
import SandpackEditor from './SandpackEditor';
import MonacoEditor from './MonacoEditor';
import { CODING_LANGUAGE, intialCodeOfLang } from '@lib/constants';

function Compiler({ selectedLang = 'javascript', setLang }) {
  const optionsData = {
    languages: CODING_LANGUAGE,
    defaultLanguage: selectedLang,
  };

  const isReactLang = selectedLang === 'react';

  const [code, setCode] = useState('');

  const [compileStatus, setCompileStatus] = useState({
    isLoading: false,
    isError: false,
    result: '',
  });

  const [headerConfig, setHeaderConfig] = useState({
    openConfig: false,
    fullScreen: false,
    theme: 'vs-dark',
    fontSize: '14px',
  });

  const resetHandler = () => {
    setCode(intialCodeOfLang[selectedLang] || '');
    setCompileStatus({
      isLoading: false,
      isError: false,
      result: '',
    });
  };

  const changeLangHandler = (lang) => {
    setLang(lang);
    resetHandler();
  };

  useEffect(() => {
    if (selectedLang) {
      setCode(intialCodeOfLang[selectedLang] || '');
    }
  }, [selectedLang]);

  useLayoutEffect(() => {
    if (!headerConfig.fullScreen) return;

    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [headerConfig.fullScreen]);

  return (
    <div
      className={
        headerConfig.fullScreen
          ? 'fixed inset-0 z-[1111] h-screen bg-black'
          : 'bg-[#121212] pt-3 pb-6 md:py-6'
      }
      onClick={() => setHeaderConfig((prev) => ({ ...prev, openConfig: false }))}
    >
      <OptionsHeader
        optionsData={optionsData}
        selectedLang={selectedLang}
        setLang={changeLangHandler}
        resetHandler={resetHandler}
        headerConfig={headerConfig}
        setHeaderConfig={setHeaderConfig}
      />

      {isReactLang ? (
        <SandpackEditor selectedLang={selectedLang} config={headerConfig} />
      ) : (
        <MonacoEditor
          selectedLang={selectedLang}
          code={code}
          setCode={setCode}
          compileStatus={compileStatus}
          setCompileStatus={setCompileStatus}
          config={headerConfig}
        />
      )}
    </div>
  );
}

export default Compiler;
